<template>
    <div class="container search">
        <div class="row">
            <div class="col-md-12">
                <div class="row flex-column-reverse flex-sm-row">
                    <div class="col-md-6">
                        <h2>
                            Edit Company
                        </h2>
                    </div>
                </div>
                <EditCompany :company="company"></EditCompany>
            </div>
        </div>
    </div>
</template>
<script>
import EditCompany from './EditCompany'
import axios from "axios";
export default {
    props: [
        'company_id',
    ],
    components: {
        EditCompany
    },
    created() {
        this.getCompany()
    },
    mounted() {
    },
    data() {
        return {
            company: null
        }
    },
    computed: {},
    methods: {
        async getCompany(){
            const res = await axios.get(this.$laravelRoute('companies.show', this.company_id));
            if (res && res.data && res.data.company) {
                this.company = res.data.company
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Companies/EditCompanyPage.vue